import type { ReactNode } from "react";
import { cn } from "@/lib/cn";
import { AdminIcon, type IconName } from "./icon";

interface KpiProps {
	label: string;
	value: ReactNode;
	variant?: "default" | "accent" | "success" | "warning" | "forest" | "ochre" | "info";
	delta?: ReactNode;
	deltaVariant?: "up" | "down" | "neutral" | "accent" | "forest" | "warning" | "success";
	icon?: IconName;
	foot?: ReactNode;
	spark?: ReactNode;
	children?: ReactNode;
}

export function Kpi({
	label,
	value,
	variant = "default",
	delta,
	deltaVariant,
	icon,
	foot,
	spark,
	children,
}: KpiProps) {
	return (
		<div className={cn("kpi", variant !== "default" && variant)}>
			<div className="kpi-head">
				<div className="kpi-l">{label}</div>
				{icon && (
					<div className={cn("kpi-icon-wrap", variant)}>
						<AdminIcon n={icon} s={16} />
					</div>
				)}
			</div>
			<div className="kpi-body">
				<div className="kpi-v tn">{value}</div>
				{spark}
			</div>
			{delta && <span className={cn("kpi-delta", deltaVariant)}>{delta}</span>}
			{foot && <div className="kpi-foot">{foot}</div>}
			{children}
		</div>
	);
}

